import {createGlobalStyle} from 'styled-components';

import reset from './reset';
import {customScrollbarClass} from './StyledCustomScrollbar';
import FiltersEllipsisTooltip from './FiltersEllipsisTooltip';

export default createGlobalStyle`
	${reset}
	${customScrollbarClass}
	${FiltersEllipsisTooltip}
`;
